'use client'

import { KeyboardEvent } from 'react'
import { Cell, Icon, Spacer, Text } from '@vinted/web-ui'
import { ChevronRight24, Gift24 } from '@vinted/monochrome-icons'

import { KeyboardKey, onA11yKeyDown } from '@marketplace-web/vendor-abstractions/web-ui-util'

type Props = {
  isVisible: boolean
  onClick: () => void
}

const OfferBanner = ({ isVisible, onClick }: Props) => {
  if (!isVisible) return null

  const handleKeyDown = (event: KeyboardEvent) =>
    onA11yKeyDown(event, { keys: [KeyboardKey.Enter, KeyboardKey.Space] }, onClick)

  return (
    <>
      <Spacer size="large" />
      <div
        className="digital-label-offer__ad-banner"
        role="button"
        onClick={onClick}
        onKeyDown={handleKeyDown}
        tabIndex={0}
      >
        <Cell
          theme="transparent"
          prefix={<Icon name={Gift24} color="greyscale-level-2" />}
          body={<Text as="span" text="Partner offers available" type="title" theme="amplified" />}
          suffix={<Icon name={ChevronRight24} color="greyscale-level-2" />}
        />
      </div>
    </>
  )
}

export default OfferBanner
